
    import './styles.scoped.css';
    export default {
  "head": "awsui_head_1otu2_ixe2a_5",
  "head-grid": "awsui_head-grid_1otu2_ixe2a_9"
};
  